import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Divider from "@amzn/meridian/esm/components/divider";
import Row from "@amzn/meridian/esm/components/row";
import Icon from "@amzn/meridian/esm/components/icon";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import calendarTokens from "@amzn/meridian-tokens/base/icon/calendar";
import SummaryBodyInDetailPage from "../../common/summary/SummaryBodyInDetailPage";
import SummaryFeedback from "../../common/feedback/SummaryFeedback";
import SummaryListButton from "../../common/summary/SummaryListButton";
import SummaryNotApprovedFeedback from "../../common/feedback/SummaryNotApprovedFeedback";
import { SUMMARY_FEEDBACK_STATUS, SUMMARY_TYPES } from "../../common/summary/constants";
import LogManager from "../../utils/LogManager";
import AttendeeListInDetailPage from "../../common/summary/AttendeeListInDetailPage";

/**
 * SummaryDetail - Detail view for a selected summary.
 * Same content as inMeeting/summary/SummaryDetails.jsx but without AimsMasthead.
 * Uses onBack callback instead of route navigation.
 */
const SummaryDetail = ({ summary, onBack, isSessionActive }) => {
  if (!summary) {
    LogManager.error("No summary in SummaryDetail view. This should not happen.");
    return (
      <Column>
        <Text type="b200" color="error">
          Summary not found.
        </Text>
      </Column>
    );
  }

  const summaryFeedbackStatus = SUMMARY_TYPES.APPROVED.includes(summary?.summaryType) 
    ? SUMMARY_FEEDBACK_STATUS.APPROVED
    : SUMMARY_TYPES.NOT_APPROVED.includes(summary?.summaryType)
    ? SUMMARY_FEEDBACK_STATUS.NOT_APPROVED
    : SUMMARY_FEEDBACK_STATUS.OTHER;

  const showFeedback = (!summary.feedback && !summary.feedbackComment) && summaryFeedbackStatus !== SUMMARY_FEEDBACK_STATUS.OTHER;

  return (
    <Column spacing="none" height={isSessionActive ? "calc(100vh - 131px)" : "calc(100vh - 75px)"} heights={showFeedback ? ["fit", "fill", "fit"] : ["fit", "fill"]}>
      <Column spacing="none">
        <Column height="16px" />
        {/* "Summary list" back button */}
        <SummaryListButton onSummaryListInClient={onBack} />
        <Column height="24px" />
      </Column>

      <Column width="362px" spacing="none" spacingInset="0 500" overflowY="scroll">
          <Column spacing="none" spacingInset="none">
            {/* Summary title */}
            <Text type="h200">
              {summary.meetingTitle}
            </Text>
            <Column height="20px" />

            {/* Summary time with calendar icon */}
            <Row spacing="none" spacingInset="none">
              <Icon tokens={calendarTokens} color="secondary" />
              <Row width="4px" />
              <Text type="b100" color="secondary" fontFamily="amazonEmber" className="summary-time">
                {summary.meetingDateAndTime}
              </Text>
            </Row>

            <Column height="8px" />

            {/* Attendee list */}
            <AttendeeListInDetailPage attendeeNameList={summary.attendeeNameList} />

            {/* Divider */}
            <Column height="16px" />
            <Divider spacingBefore="0" spacingAfter="0" />
            <Column height="16px" />

            <SummaryBodyInDetailPage summary={summary} isTopicNotApproved={summaryFeedbackStatus === SUMMARY_FEEDBACK_STATUS.NOT_APPROVED}/>
          </Column>
      </Column>

      {/* Feedback */}
      {showFeedback && (
        <Column width="362px" spacingInset="0 300">
          {summaryFeedbackStatus === SUMMARY_FEEDBACK_STATUS.APPROVED ? (
            <SummaryFeedback aimsUuid={summary.aimsUuid} />
          ) : (
            <SummaryNotApprovedFeedback aimsUuid={summary.aimsUuid} />
          )}
        </Column>
      )}
    </Column>
  );
};

export default SummaryDetail;
